module.exports = __webpack_public_path__ + "img/inicio.3ef6ed12.png";